// extracted by mini-css-extract-plugin
export default {"data":"style_data__I4Qq7"};